import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useValidateQueryParams } from "query_parameters/paramsHelper";
import { validParamsProfile } from "query_parameters/valid_parameters_profile";
import { useQueryString } from "hooks/general-hooks";
import { removeKeys, updateQueryParamsIfChanged } from "lib/general-helper";

import MediaQuery from "components/MediaQuery";
import QueueType from "components/FilterManager/Filters/QueueType";
import Role from "components/FilterManager/Filters/Role";
import RoleSplit from "components/FilterManager/Filters/RoleSplit";
import Season from "components/FilterManager/Filters/Season";
import { ReactComponent as FilterIcon } from "svg/filters-icon.svg";

const ProfileFilterManager = (props) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams();

  const { className, isMobile, page, disable, enable } = props;

  const onResetFilters = () => {
    history.replace({
      pathname: location.pathname,
    });
  };

  const updateQueryParams = (newFilter) => {
    // delete filters that we don't need
    const curFilter = removeKeys(newFilter, disable || []);
    updateQueryParamsIfChanged(history, location, curFilter);
  };

  const onFilterChange = (filterType, filterValue) => {
    let newFilter = {};
    if (filterType && filterValue) {
      newFilter[filterType] = filterValue.value;

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "filter-select",
          category: "filter",
          filterType,
          filterValue: filterValue.value,
          page,
        });
      }
    }

    if (filterType === "queueType" && filterValue !== "normal_aram" && filterValue !== "nexus_blitz") {
      delete newFilter.role;
    }
    newFilter = { ...queryParams, ...newFilter };
    newFilter = validateQueryParams({ queryParams: newFilter, page, queryParamType: "profile" });
    updateQueryParams(newFilter);
  };

  const validPageParams = validParamsProfile[page] || {};
  const defaultParams = validPageParams.default || {};
  const filters = Object.assign({}, defaultParams, queryParams);

  const options = { ...validPageParams };
  const filterProps = {
    isMobile,
    onFilterChange,
    history,
    location,
    filters,
  };

  return (
    <div className={`filter-manager ${className}`}>
      <div className="filter-width-wrapper">
        <div className="filter-manager_container">
          <div className="filter-manager_label">
            <FilterIcon />
            <MediaQuery min="TABLET" max="DESKTOP_LARGE">
              <span>Filters</span>
            </MediaQuery>
          </div>
          <React.Fragment>
            <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
              <Role {...filterProps} options={options.role} />
            </MediaQuery>
            <MediaQuery min="TABLET" max="DESKTOP_LARGE">
              <RoleSplit {...filterProps} allRoles />
            </MediaQuery>
          </React.Fragment>
          {/*<RoleSplit {...filterProps} allRoles />*/}
          <QueueType {...filterProps} options={options.queueType} />
          <Season {...filterProps} options={options.season} />
          {/*
            location.search && location.search.substring(1) !== "" && (
              <div className="reset-filters" onClick={onResetFilters}>
                Reset
              </div>
            )
          */}
        </div>
      </div>
    </div>
  );
};

ProfileFilterManager.defaultProps = {
  enable: [], // Array of keys to enable. playerType is disabled by default
  disable: [], // Array of keys to disable/hide specific filters
  allRoles: false, // Allow all roles to be selected, otherwise define own filtering of roles
  alwaysResetFilters: false,
};

export default ProfileFilterManager;
